module.exports = __webpack_public_path__ + "images/global-internet-usage.jpg";